import React from 'react';

import { Card, labelClass } from '../ui';
import { fieldClass, TClassForm, TSetField } from './shared';

type Props = {
  form: TClassForm;
  set: TSetField;
};

/** Contracted seats and client confirmation. */
const CsmSection: React.FC<Props> = ({ form, set }) => (
  <Card title="CSM">
    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-2">
      <div>
        <label className={labelClass}>Contract no. of students</label>
        <input
          type="number"
          min="0"
          className={fieldClass}
          value={form.seats}
          onChange={(e) => set('seats')(e.target.value)}
        />
      </div>
      <label className="flex items-center gap-2 self-end pb-2 text-sm text-gray-five">
        <input
          type="checkbox"
          className="ops-check h-4 w-4 accent-blue-primary"
          checked={form.clientConfirmed}
          onChange={(e) => set('clientConfirmed')(e.target.checked)}
        />
        Client confirmed
      </label>
    </div>
  </Card>
);

export default CsmSection;
